import callApi from "./index";
import API_URL from "../constants/urlPaths";

export default {
  // Lead

  getLeadList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.LEAD + url,
      })
      .then((res) => res.data);
  },

  getLeadListFilter(url = "", data) {
    return callApi
      .request({
        method: "POST",
        data,
        url: API_URL.LEAD + "/filter" + url,
      })
      .then((res) => res.data);
  },

  editLead(url, data) {
    return callApi
      .request({
        method: "PUT",
        url: API_URL.LEAD + url,
        data,
      })
      .then((res) => res.data);
  },

  getItemLead(url) {
    return callApi
      .request({
        method: "GET",
        url: API_URL.LEAD + url,
      })
      .then((res) => res.data);
  },

  deleteLead(url) {
    return callApi
      .request({
        method: "DELETE",
        url: API_URL.LEAD + url,
      })
      .then((res) => res.data);
  },

  createLead(data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.CREATE_LEAD,
        data,
      })
      .then((res) => res.data);
  },

  // статусы CRM партнёра, которые приходили по лидам интеграции (для настройки валидных статусов)
  getPartnerStatuses(integrationId) {
    return callApi
      .request({
        method: "GET",
        url: API_URL.LEAD + "/partner-statuses",
        params: { integration_id: integrationId },
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  getLeadStatus() {
    return callApi
      .request({
        method: "GET",
        url: API_URL.LEAD_STATUS,
      })
      .then((res) => res.data);
  },

  exportLead(data, url = "") {
    return callApi
      .request({
        method: "POST",
        url: API_URL.EXPORT_LEAD + "?with[0]=country&with[1]=integration&with[2]=status" + url,
        data,
      })
      .then((res) => {
        console.log(res);

        const blob = new Blob([res.data]);
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "leads_export.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();

        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error(this.$t("api.downloadError"), err);
      });
  },

  getLeadJobsList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.LEAD_JOBS + url,
      })
      .then((res) => res.data);
  },

  getLeadParamsList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.LEAD_PARAMS + url,
      })
      .then((res) => res.data);
  },

  getLeadParamsItemsList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.LEAD_PARAMS_ITEMS + url,
      })
      .then((res) => res.data);
  },

  leadReimport(data, id = null) {
    return callApi
      .request({
        method: "POST",
        data,
        url: API_URL.LEAD_REIMPORT,
        headers: {
          "user-id": id,
        },
      })
      .then((res) => res.data);
  },

  leadRevoke(data) {
    return callApi
      .request({
        method: "POST",
        data,
        url: API_URL.LEAD_REVOKE,
      })
      .then((res) => res.data);
  },

  // Client

  getClientList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.CLIENT + url,
      })
      .then((res) => res.data);
  },

  getClientListAll(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.CLIENT_ALL + url,
      })
      .then((res) => res.data);
  },

  editClient(url, data) {
    return callApi
      .request({
        method: "PUT",
        url: API_URL.CLIENT + url,
        data,
      })
      .then((res) => res.data);
  },

  getItemClient(url) {
    return callApi
      .request({
        method: "GET",
        url: API_URL.CLIENT + url,
      })
      .then((res) => res.data);
  },

  deleteClient(url) {
    return callApi
      .request({
        method: "DELETE",
        url: API_URL.CLIENT + url,
      })
      .then((res) => res.data);
  },

  createClient(data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.CLIENT,
        data,
      })
      .then((res) => res.data);
  },

  // Integration

  getIntegrationList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.INTEGRATION + url,
      })
      .then((res) => res.data);
  },

  getIntegrationListGroup(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.INTEGRATION + "/grouped-by-language" + url,
      })
      .then((res) => res.data);
  },

  getIntegrationListAvailable(url = "?isAll=1") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.INTEGRATION_AVAILABLE + url,
      })
      .then((res) => res.data);
  },

  getIntegrationAll() {
    return callApi
      .request({
        method: "GET",
        url: API_URL.INTEGRATION + "/all",
      })
      .then((res) => res.data);
  },

  editIntegration(url, data) {
    return callApi
      .request({
        method: "PUT",
        url: API_URL.INTEGRATION + url,
        data,
      })
      .then((res) => res.data);
  },

  // только валидные статусы партнёра (доступно и аффилейт-менеджеру для своих интеграций)
  updateIntegrationValidStatuses(id, validStatuses) {
    return callApi
      .request({
        method: "PUT",
        url: API_URL.INTEGRATION + `/${id}/valid-statuses`,
        data: { valid_statuses: validStatuses },
      })
      .then((res) => res.data);
  },

  // квоты команд внутри интеграции: отдельный экран и отдельное сохранение
  getIntegrationQuotas(id) {
    return callApi
      .request({
        method: "GET",
        url: API_URL.INTEGRATION + `/${id}/quotas`,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  updateIntegrationQuotas(id, data) {
    return callApi
      .request({
        method: "PUT",
        url: API_URL.INTEGRATION + `/${id}/quotas`,
        data,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  // «сегодня по командам»: принято партнёром и отправлено без ответа
  getIntegrationQuotaUsage(id) {
    return callApi
      .request({
        method: "GET",
        url: API_URL.DISTRIBUTION_LEAD_LOG + "/quota-usage",
        params: { integration_id: id },
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  // почему лид не ушёл ни в одну интеграцию
  getLeadStopReason(leadId) {
    return callApi
      .request({
        method: "GET",
        url: API_URL.DISTRIBUTION_LEAD_LOG + "/stop-reason",
        params: { lead_id: leadId },
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  getItemIntegration(url) {
    return callApi
      .request({
        method: "GET",
        url: API_URL.INTEGRATION + url,
      })
      .then((res) => res.data);
  },

  deleteIntegration(url) {
    return callApi
      .request({
        method: "DELETE",
        url: API_URL.INTEGRATION + url,
      })
      .then((res) => res.data);
  },

  createIntegration(data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.INTEGRATION,
        data,
      })
      .then((res) => res.data);
  },

  getIntegrationType(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.INTEGRATION_TYPE + url,
      })
      .then((res) => res.data);
  },

  getIntegrationLog(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.INTEGRATION_LOG + url,
      })
      .then((res) => res.data);
  },

  // Country

  getCountryList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.COUNTRY_LIST + url,
      })
      .then((res) => res.data);
  },

  getLanguageList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.LANGUAGE_LIST + url,
      })
      .then((res) => res.data);
  },

  // Ответы партнёров на отправку лида (задача 11). Снэйк-кейс контракта оставляем
  // как есть — поля приходят сгруппированными строками, переименовывать их незачем.
  getIntegrationResponses(data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.INTEGRATION_RESPONSES + "/filter",
        data,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  getIntegrationResponsesUnreadCount() {
    return callApi
      .request({
        method: "GET",
        url: API_URL.INTEGRATION_RESPONSES + "/unread-count",
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  resolveIntegrationResponses(data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.INTEGRATION_RESPONSES + "/resolve",
        data,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  getIntegrationHistoryList(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.INTEGRATION_HISTORY + url,
      })
      .then((res) => res.data);
  },

  // Log Global

  getGlobalLog(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.LOG_GLOBAL + url,
      })
      .then((res) => res.data);
  },

  getDistributionLeadLog(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.DISTRIBUTION_LEAD_LOG + url,
      })
      .then((res) => res.data);
  },

  getLeadLog(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.LEAD_LOG + url,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  getLogStatus() {
    return callApi
      .request({
        method: "GET",
        url: API_URL.GET_LOG_STATUS,
      })
      .then((res) => res.data);
  },

  getQueue() {
    return callApi
      .request({
        method: "GET",
        url: API_URL.QUEUE,
      })
      .then((res) => res.data);
  },
  putQueue(data) {
    return callApi
      .request({
        method: "PUT",
        url: API_URL.QUEUE,
        data,
      })
      .then((res) => res.data);
  },
  sendLead(data, id = null) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.SEND_LEAD,
        data,
        headers: {
          "user-id": id,
        },
      })
      .then((res) => res.data);
  },
  getBuyerDeposit(url = "", data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.BUYER_DEPOSIT + url,
        data,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },
  getCompaignReport(url = "", data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.COMPAIGN + url,
        disableCamelCase: true,
        data,
      })
      .then((res) => res.data);
  },
  getCountryDeposit(url = "", data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.COUNTRY_DEPOSIT + url,
        data,
      })
      .then((res) => res.data);
  },

  exportCompaignReport(data, url) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.COMPAIGN_EXPORT + url,
        data,
      })
      .then((res) => {
        console.log(res);

        const blob = new Blob([res.data]);
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "compaign_report_export.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();

        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error(this.$t("api.downloadError"), err);
      });
  },

  //country

  getCountryListDisable(url = "") {
    return callApi
      .request({
        method: "GET",
        url: API_URL.COUNTRY + url,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  createCountry(data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.COUNTRY,
        data,
      })
      .then((res) => res.data);
  },

  editCountry(url, data) {
    return callApi
      .request({
        method: "PUT",
        url: API_URL.COUNTRY + url,
        data,
      })
      .then((res) => res.data);
  },

  getItemCountry(url) {
    return callApi
      .request({
        method: "GET",
        url: API_URL.COUNTRY + url,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },

  deleteCountry(url) {
    return callApi
      .request({
        method: "DELETE",
        url: API_URL.COUNTRY + url,
      })
      .then((res) => res.data);
  },

  getTelegramConfig() {
    return callApi
      .request({
        method: "GET",
        url: API_URL.TELEGRAM_CONFIG,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },
  getTelegramRec() {
    return callApi
      .request({
        method: "GET",
        url: API_URL.TELEGRAM_REC,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },
  saveTelegramConfig(data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.TELEGRAM_CONFIG,
        data,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },
  saveTelegramRec(data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.TELEGRAM_REC,
        data,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },
  sendTelegramConfig() {
    return callApi
      .request({
        method: "POST",
        url: API_URL.TELEGRAM_CONFIG_SEND,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },
  sendTelegramRec(data) {
    return callApi
      .request({
        method: "POST",
        url: API_URL.TELEGRAM_REC_SEND,
        data,
        disableCamelCase: true,
      })
      .then((res) => res.data);
  },
};
